import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface PostAdminAccountRequest {
    a_id: string;
    a_pwd: string;
    a_name: string;
}

interface PostAdminAccountResponse {
    statusCode: number;
    message: string;
    data: { idx: number };
}

export const usePostConsoleAdminAccount = (): UseMutationResult<PostAdminAccountResponse, Error, PostAdminAccountRequest> => {
    const queryClient = useQueryClient();

    return useMutation<PostAdminAccountResponse, Error, PostAdminAccountRequest>({
        mutationFn: async (body) => {
            const response = await axiosInstance.post(enum_api_uri.post_console_admin_account, body);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleAdminAccounts"] });
        },
    });
};
